var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"p-5 text-center"},[_vm._v(_vm._s(_vm.$t("payments.SUCCESS_WAITING")))]),_c('div',{staticClass:"justify-content-center mt-2 text-center"},[_c('md-progress-spinner',{staticClass:"mt-4",attrs:{"md-mode":"indeterminate"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }